import * as React from 'react';
import { IOutput, EOutputLookupContext } from '../../helpers';
import { ContentEditableTinyMCE, Values } from '../';
import { Label, IDropdownOption, Pivot, PivotItem, PivotLinkSize, } from 'office-ui-fabric-react';

interface IProps {
	outputs: IOutput[];
	outputOptions: IDropdownOption[];
	globalOutputDropdownOptions: IDropdownOption[];
	sharedJourneyId: string;
	
	updateOutput: (index: number, name: string) => void;
    outputBlur: (index: number, name: string, staticName: string, logicalName: string) => void;
    updateSelectedGlobalOutput: (index:number, key: string) => void;
    updateSelectedOutputType: (index: number, type: number) => void;
    updateOutputLogicalName: (index: number, logicalName: string) => void;
	updateOutputDefaultValue: (index: number, defaultValue: string) => void;
	addSharedJourneyOutput: () => void;
    deleteSharedJourneyOutput: (index: number) => void;
		
	setInputValue: (outputId: string, value: string) => void;
}

export class SharedJourneyConfig extends React.Component<IProps, any> {

	public render() {

		let { outputs, setInputValue, sharedJourneyId, outputOptions, globalOutputDropdownOptions,
			updateOutput, outputBlur, updateSelectedGlobalOutput, updateSelectedOutputType, updateOutputLogicalName, updateOutputDefaultValue
		} = this.props;

		let inputItems: JSX.Element[] = sharedJourneyId && sharedJourneyId.length ? outputs
			.filter(o => o.CanBeSetByQueryString)
			.map((o, i) => {
				return (
					<li key={'output-' + i}>
						<Label value={o.Name} className='input-name'>{o.OutputLabelFromSharedJourney || o.Name}</Label>
						<ContentEditableTinyMCE 
                  			value={ o.InputValue }
							outputOptions={ outputOptions || [] }
                  			singleLine={ true }
                  			richText={ false }
							onBlur= {
								v => setInputValue(o.Id, v)
							}
							readonly={false}
							outputLookupContext={EOutputLookupContext.NotSpecified}
						/>						
					</li>
				);
			}) : [];

		let pivots: JSX.Element[] = [];

		if(inputItems) {
			pivots.push(
				<PivotItem key="pivot_inputs" linkText='Inputs'>
					<ul className='shared-journey-config-inputs'>
						<li key='title-row'>
							<Label value='Input Name' className='input-name'>Input Name</Label>
							<Label value='Input Value' className='input-value'>Input Value</Label>
						</li>
						{inputItems}
					</ul>					
				</PivotItem>
			);
		}

		if(outputs) {

			//TODO: create shared journey output configuration
			pivots.push(
				<PivotItem key="pivot_outputs" linkText='Outputs'>
					<Values
						outputs={ outputs }
						globalOutputDropdownOptions={ globalOutputDropdownOptions }
						outputDropdownOptions={ outputOptions }
						sharedJourneyMode={true}
						outputHandler={{
							updateOutput: updateOutput,
							outputBlur: outputBlur,
							updateSelectedGlobalOutput: updateSelectedGlobalOutput,
							updateSelectedOutputType: updateSelectedOutputType,
							updateOutputLogicalName: updateOutputLogicalName,
							updateOutputDefaultValue: updateOutputDefaultValue
						}}
					/>					
				</PivotItem>
			);
		}

		return (
			<Pivot linkSize={ PivotLinkSize.large }>                    
				{ pivots }
			</Pivot>
		);

	}

}


// WEBPACK FOOTER //
// ./source/ts/components/shared-journey/shared-journey-config.tsx